import React, { useState, useEffect } from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import * as apiMethods from "../res/apiMethods.js";
import { makeStyles } from '@mui/styles';
import Tooltip from "@mui/material/Tooltip";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useFormik } from "formik";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import { DataGrid } from "@mui/x-data-grid";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { NumericFormat } from 'react-number-format';
import * as yup from "yup";
import Swal from "sweetalert2";
import Sidebar from "../components/Sidebar";
import AccessDenied from "./accessDenied";
import ReactDatePicker from "react-datepicker";
import TextField from "@mui/material/TextField";
import { registerLocale } from  "react-datepicker";
import { es } from 'date-fns/locale/es';
import InputAdornment from "@mui/material/InputAdornment";
import TodayIcon from '@mui/icons-material/Today';
registerLocale('es', es);

const parseDate = (date) => {
  if (!date) return null;
  const parsedDate = new Date(date);
  return isNaN(parsedDate.getTime()) ? null : parsedDate;
};

const Clients = () => {
  const [props, setProps] = useState({
    exists: false,
    clientCredits: [],
    user: "",
    puedeEliminar: false, // ← NUEVO
  });

useEffect(() => {
  (async () => {
    if (getLastItem(window.location.href) !== "clients") {
      Swal.fire({ title: "Cargando", allowOutsideClick: false });
      Swal.showLoading();
      
      try {
        // UNA SOLA petición en lugar de DOS
        const response = await axios.get(
          apiMethods.GET_CLIENTE_COMPLETO + getLastItem(window.location.href)
        );

        if (response.data.code === 0) {
          formik.resetForm({ values: response.data.cliente });
          setState({ 
            clientCredits: response.data.creditos, 
            exists: true,
            puedeEliminar: response.data.puedeEliminar 
          });
        } else {
          toast.error(response.data.message || 'Error al cargar cliente');
        }
      } catch (error) {
        console.error('Error cargando cliente:', error);
        toast.error('Error al cargar los datos del cliente');
      }
      
      Swal.close();
    }
    
    setState({
      user: JSON.parse(
        atob(window.sessionStorage.getItem("localToken").split(".")[1])
      ),
    });
  })();
}, []);

  const validationSchema = yup.object().shape({
    telefono: yup
      .string()
      .min(11, "El teléfono debe ser por lo menos de 7 digitos")
      .max(14, "El teléfono debe ser de máximo 10 digitos"),
    email: yup.string().email(),
    birthDate: yup.date(),
  });

  const formik = useFormik({
    initialValues: {
      tipoDocumento: "",
      documento: "",
      nombre: "",
      telefono: "",
      direccion: "",
      email: "",
      birthDate: null,
      notas: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      submitHandler(values);
    },
  });

  const onError = (e) => {
    e.preventDefault();
    
    for (let error in formik.errors) {
      toast.error(formik.errors[error]);
    }
  };

  const setState = (value) => {
    setProps((prevState) => ({ ...prevState, ...value }));
  };

  const getLastItem = (thePath) =>
    thePath.substring(thePath.lastIndexOf("/") + 1);

  const createCredit = () => {
    axios
      .get(apiMethods.GET_CLIENTE_DOCUMENTO + getLastItem(window.location.href))
      .then((response) => {
        var auxClient = [];
        auxClient.push(response.data.client);
        window.sessionStorage.setItem(
          "clientStored",
          getLastItem(window.location.href)
        );
        window.location.href = "/credits";
      })
      .catch((error) => {
        
      });
  };

  const removeClient = async () => {
    // Validación previa (opcional, ya está en backend)
    if (!props.puedeEliminar) {
      toast.error("No se puede eliminar el cliente porque tiene créditos");
      return;
    }

    try {
      Swal.fire({
        title: '¿Estás seguro?',
        text: "Esta acción no se puede deshacer",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then(async (result) => {
        if (result.isConfirmed) {
          Swal.fire({ title: "Eliminando...", allowOutsideClick: false });
          Swal.showLoading();

          const actUsrToken = window.sessionStorage.getItem("localToken");
          
          // UNA SOLA petición en lugar de 6-7
          const response = await axios.post(
            apiMethods.DELETE_CLIENTE_COMPLETO + getLastItem(window.location.href),
            null,
            {
              headers: {
                Authorization: actUsrToken,
              },
            }
          );

          Swal.close();

          if (response.data.code === 0) {
            toast.success('Cliente eliminado exitosamente');
            setTimeout(() => {
              window.location.href = "/home";
            }, 1500);
          } else {
            toast.error(response.data.message || 'Error al eliminar cliente');
          }
        }
      });
    } catch (error) {
      Swal.close();
      console.error('Error eliminando cliente:', error);
      toast.error("Error al eliminar el cliente");
    }
  };

  const submitHandler = async (e) => {
  e.preventDefault();
  
  const actUsrToken = window.sessionStorage.getItem("localToken");

  if (props.exists) {
    // ========================================
    // ACTUALIZAR CLIENTE EXISTENTE (mantiene endpoint actual)
    // ========================================
    try {
      Swal.fire({ title: "Actualizando...", allowOutsideClick: false });
      Swal.showLoading();

      const response = await axios.patch(
        apiMethods.PATCH_CLIENTE_DOCUMENTO + getLastItem(window.location.href),
        formik.values,
        {
          headers: {
            Authorization: actUsrToken,
          },
        }
      );

      Swal.close();

      if (response.data.code === 0 || response.status === 200) {
        toast.success('Cliente actualizado exitosamente');
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        toast.error('Error al actualizar el cliente');
      }
    } catch (error) {
      Swal.close();
      console.error('Error actualizando:', error);
      toast.error("Error al actualizar el cliente");
    }
  } else {
    // ========================================
    // CREAR NUEVO CLIENTE (usa endpoint completo)
    // ========================================
    try {
      Swal.fire({ title: "Creando cliente...", allowOutsideClick: false });
      Swal.showLoading();

      // UNA SOLA petición en lugar de 5
      const response = await axios.post(
        apiMethods.CREATE_CLIENTE_COMPLETO,
        formik.values,
        {
          headers: {
            Authorization: actUsrToken,
          },
        }
      );

      Swal.close();

      if (response.data.code === 0) {
        toast.success('Cliente registrado con éxito');
        setTimeout(() => {
          window.location.href = `/clients/${formik.values.documento}`;
        }, 1500);
      } else if (response.data.code === 409) {
        toast.error('El documento ya se encuentra registrado');
      } else {
        toast.error(response.data.message || 'Error al crear el cliente');
      }
    } catch (error) {
      Swal.close();
      console.error('Error creando cliente:', error);
      toast.error("Error al crear el cliente");
    }
  }
};

  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: "70%",
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));

  const classes = useStyles();

  const DatePickerState = ({ onClick }) => (
    <Button
    className="react-datepicker-ignore-onclickoutside"
    onClick={onClick}
    id="datePicker"
  >
    <TodayIcon style={{ fontSize: 24 }} />
  </Button>
  );

  const renderDetailsButton = (params) => {
    return (
      <strong>
        <Button
          variant="contained"
          sx={{
              backgroundColor: 'rgb(238, 238, 238)',
              color: "black",
              '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
          }}
          size="small"
          onClick={() => {
            const creditId = params.row.id; 
            window.sessionStorage.setItem("localDocument", creditId);
            //history.push('/detailCreditos');
            window.location.href = `/credits/${creditId}`;
          }}
        >
          Abrir
        </Button>
      </strong>
    );
  };

  const creditsColumns = [
    { field: "id", headerName: "Documento", width: "250" },
    { field: "vlrCapital", headerName: "Capital", width: "250" },
    { field: "plazo", headerName: "Plazo", width: "250" },
    {
      field: "accion",
      headerName: "Acción",
      width: "150",
      renderCell: renderDetailsButton,
    },
  ];

  return window.sessionStorage.getItem("localToken") ? (
    <React.Fragment>
      <ToastContainer />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <div style={{ display: "grid", gridTemplateColumns: "15% 85%" }}>
          <Sidebar />
          <div>
            <div className="card" style={{ width: "100%" }}>
              <div
                style={{
                  fontSize: "15pt",
                  fontWeight: "500",
                  marginBottom: "1rem",
                  marginTop: "1rem",
                  marginLeft: "1rem",
                }}
              >
                {props.exists ? "Detalle Cliente" : "Registro Cliente"}
              </div>
              <form
                onSubmit={(e) => {
                  formik.isValid ? submitHandler(e) : onError(e);
                }}
              >
                <div
                  style={{ display: "grid", gridTemplateColumns: "auto auto" }}
                >
                  <div className="create-credit-input-row">
                    <FormControl className={`${classes.formControl} create-credit-input`}>
                      <InputLabel>Tipo de documento *</InputLabel>
                      <Select
                        label="Tipo de documento *"
                        defaultValue="Cédula de Ciudadanía"
                        disabled={props.exists || props.user?.roleId !== 1}
                        required
                        id="tipoDocumento"
                        name="tipoDocumento"
                        style={{ textAlign: "left" }}
                        value={formik.values.tipoDocumento}
                        onChange={formik.handleChange}
                      >
                        <MenuItem value="C.C.">Cédula de Ciudadanía</MenuItem>
                        <MenuItem value="C.E.">Cédula de Extranjería</MenuItem>
                        <MenuItem value="N.I.T.">N.I.T.</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="create-credit-input-row">
                    <TextField
                      required
                      label="Número de documento"
                      className="create-credit-input"
                      id="documento"
                      disabled={props.exists || props.user?.roleId !== 1}
                      value={formik.values.documento}
                      onChange={formik.handleChange}
                    />
                  </div>
                  <div className="create-credit-input-row">
                    <TextField
                      required
                      className="create-credit-input"
                      label="Nombre"
                      disabled={props.user?.roleId == 1 ? false : true}
                      id="nombre"
                      value={formik.values.nombre}
                      onChange={formik.handleChange}
                    />
                  </div>
                  <div className="create-credit-input-row">
                    <NumericFormat 
                      customInput={TextField}
                      label="Teléfono / Celular"
                      className="create-credit-input"
                      required
                      id="telefono"
                      disabled={props.user?.roleId == 1 ? false : true}
                      format="(###) ###-####"
                      value={formik.values.telefono}
                      onChange={formik.handleChange}
                    />
                  </div>
                  <div className="create-credit-input-row">
                    <TextField
                      required
                      className="create-credit-input"
                      label="Dirección"
                      id="direccion"
                      disabled={props.user?.roleId == 1 ? false : true}
                      value={formik.values.direccion}
                      onChange={formik.handleChange}
                    />
                  </div>
                  <div className="create-credit-input-row">
                    <TextField
                      required
                      type="email"
                      className="create-credit-input"
                      label="Email"
                      id="email"
                      disabled={props.user?.roleId == 1 ? false : true}
                      value={formik.values.email}
                      onChange={formik.handleChange}
                    />
                  </div>
                  <div className="create-credit-input-row">
                    <TextField
                      label="Fecha de nacimiento"
                      style={{ width: "70%" }}
                      margin="normal"
                      variant="standard"
                      disabled={props.user?.roleId !== 1}
                      value={formik.values.birthDate ? new Date(formik.values.birthDate).toLocaleDateString('es-CO') : ''}
                      slotProps={{
                        htmlInput: { style: { caretColor: "black" } },
                        input: {
                          readOnly: true,
                          endAdornment: (
                            <InputAdornment position="start">
                              <ReactDatePicker
                                locale="es"
                                disabled={props.user?.roleId !== 1}
                                dateFormat="dd/MM/yyyy"
                                id="birthDate"
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                selected={parseDate(formik.values.birthDate)}
                                onChange={(value) => formik.setFieldValue("birthDate", value)}
                                customInput={<DatePickerState />}
                              />
                            </InputAdornment>
                          ),
                        },
                      }}
                    />
                  </div>
                </div>
                <div style={{ width: "100%", textAlign: "center" }}>
                  <TextField
                    style={{ width: "85%" }}
                    multiline
                    rows={2}
                    disabled={props.user?.roleId == 1 ? false : true}
                    rowsMax={4}
                    id="notas"
                    className="create-credit-input"
                    label="Notas"
                    value={formik.values.notas}
                    onChange={formik.handleChange}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    textAlign: "left",
                    marginTop: "2.2rem",
                    marginBottom: "1.3rem",
                  }}
                >
                  {props.user?.roleId == 1 && (
                    <>
                      <Button
                        onClick={submitHandler}
                        variant="contained"
                        sx={{
                            backgroundColor: 'rgb(238, 238, 238)',
                            color: "black",
                            '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
                        }}
                        type="submit"
                        disabled={!formik.dirty}
                      >
                        Guardar
                      </Button>
                      {props.exists && (
                        <>
                        <Button
                          onClick={createCredit}
                          variant="contained"
                          sx={{
                              backgroundColor: 'rgb(238, 238, 238)',
                              color: "black",
                              '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
                          }}
                          style={{ marginLeft: "1rem" }}
                        >
                          Crear Crédito
                        </Button>
                        <Tooltip 
                          title={!props.puedeEliminar ? "No se puede eliminar porque tiene créditos asociados" : ""}
                          arrow
                          slotProps={{
                            tooltip: {
                              sx: { fontSize: 15, padding: '10px 15px', background: 'red' }
                            }
                          }}
                        >
                          <span>
                            <Button
                              variant="contained"
                              sx={{
                                  backgroundColor: 'rgb(238, 238, 238)',
                                  color: "black",
                                  '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
                              }}
                              style={{ marginLeft: "1rem" }}
                              onClick={removeClient}
                              disabled={!props.puedeEliminar}
                            >
                              Eliminar
                            </Button>
                          </span>
                        </Tooltip>
                        </>
                      )}
                    </>
                  )}
                </div>
              </form>
            </div>
          
          {props.exists && (
            <div className="card" style={{ padding: "2rem" }}>
              <div style={{ height: 300, width: "100%" }}>
                <DataGrid
                  rows={props.clientCredits}
                  columns={creditsColumns}
                  pageSize={5}
                  rowsPerPageOptions={[5, 10]}
                  disableSelectionOnClick
                />
              </div>
            </div>
          )}
          </div>
        </div>
      </LocalizationProvider>
    </React.Fragment>
  ) : (
    <AccessDenied />
  );
};

export default Clients;
